import { render, staticRenderFns } from "./RevendaGanhosSection.vue?vue&type=template&id=7789e14d&scoped=true"
import script from "./RevendaGanhosSection.vue?vue&type=script&lang=js"
export * from "./RevendaGanhosSection.vue?vue&type=script&lang=js"
import style0 from "./RevendaGanhosSection.vue?vue&type=style&index=0&id=7789e14d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7789e14d",
  null
  
)

export default component.exports